import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { SCORE_MODE_ID } from '../../../common/filterCompany/constant'
import { useSettingParams } from '../../../common/filterCompany/useSettingParams'
import { Loading } from '../../../common/loading'
import { Panel } from '../../../common/panel'
import { SCREEN } from '../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../common/selectCurrencyUnit/useFormatCurrency'
import { ScoreItem } from './ScoreItem'
import { COLORS_CORPORATE_RISK, COLORS_PERFORMANCE } from './constant'
import classes from './index.module.scss'
import {
  resetStore,
  selectCreditRisk,
  selectLoading,
  selectPerformance,
} from './store/slice'
import { exportScoreDistribution, getScoreDistribution } from './store/thunk'

export const ScoreDistribution = () => {
  const dispatch = useDispatch()

  const locale = useSelector((state) => state.i18n.locale)
  const settingParams = useSettingParams()
  const { currency } = useFormatCurrency(SCREEN.PORTFOLIO_INSIGHTS)
  const creditRisk = useSelector(selectCreditRisk)
  const performance = useSelector(selectPerformance)
  const isLoading = useSelector(selectLoading)

  useEffect(() => {
    if (settingParams) {
      dispatch(
        getScoreDistribution({
          ...settingParams,
          currency,
          scoreModelId: SCORE_MODE_ID.CORPORATE_RISK,
        }),
      )
      dispatch(
        getScoreDistribution({
          ...settingParams,
          currency,
          scoreModelId: SCORE_MODE_ID.PERFORMANCE,
        }),
      )
    }
  }, [settingParams, currency, locale])

  useEffect(() => {
    return () => resetStore()
  }, [])

  const downloadCsv = {
    downloadFunc: () => exportScoreDistribution({ ...settingParams, currency }),
    disabled:
      !settingParams ||
      isLoading ||
      (!creditRisk.length && !performance.length),
  }

  return (
    <Panel
      label="portfolio.summary.SCORE_DISTRIBUTION"
      isI18n
      className="positionRelative"
      headerStyle={{ textTransform: 'capitalize' }}
      downloadCsv={downloadCsv}
    >
      {isLoading && <Loading />}
      <div className={classes.container} style={{ opacity: isLoading ? 0 : 1 }}>
        <ScoreItem
          pieName="portfolio.summary.CREDIT_RISK_LEVEL_DISTRIBUTION"
          tableName="portfolio.summary.CREDIT_RISK_LEVEL"
          modelId={SCORE_MODE_ID.CORPORATE_RISK}
          data={creditRisk}
          colors={COLORS_CORPORATE_RISK}
        />
        <ScoreItem
          pieName="portfolio.summary.GROWTH_POTENTIAL_LEVEL_DISTRIBUTION"
          tableName="portfolio.summary.PERFORMANCE_SCORE_LEVEL"
          modelId={SCORE_MODE_ID.PERFORMANCE}
          data={performance}
          colors={COLORS_PERFORMANCE}
        />
      </div>
    </Panel>
  )
}
